app.directive(
	'compareInterestTop3', [
		'$http',
		'bezoeker',
		'$window',
		'$timeout',
		'$locale',
		function($http, bezoeker, $window, $timeout, $locale) {
			$locale.NUMBER_FORMATS.GROUP_SEP = ".";
			$locale.NUMBER_FORMATS.DECIMAL_SEP = ",";
			return {
				restrict: 'EAC',
				scope: {
					productvorm: '@?',
					titel: '@?'
				},
				templateUrl: '/templates/compare-interest-top-3.html',
				link: function($scope, $element) {

					$scope.bezoeker = bezoeker;
					$scope.productvorm = 'persoonlijke lening';
					$scope.looptijd = 72;

					$scope.bedrag = bezoeker.gewenstLeenbedrag;
					$scope.combinatieRentetarieven = false;
					$scope.firstChoice = false;

					$scope.maandlastOptions = [{
						label: '€ ' + ($scope.bedrag * 0.01).toFixed(2).replace('.', ','),
						value: 0
					}, {
						label: '€ ' + ($scope.bedrag * 0.015).toFixed(2).replace('.', ','),
						value: 1
					}, {
						label: '€ ' + ($scope.bedrag * 0.02).toFixed(2).replace('.', ','),
						value: 2
					}];
					$scope.maandlast = $scope.maandlastOptions[0];

					$scope.$watch('bedrag', function() {
						$scope.maandlastOptions = [{
							label: '€ ' + ($scope.bedrag * 0.01).toFixed(2).replace('.', ','),
							value: 0
						}, {
							label: '€ ' + ($scope.bedrag * 0.015).toFixed(2).replace('.', ','),
							value: 1
						}, {
							label: '€ ' + ($scope.bedrag * 0.02).toFixed(2).replace('.', ','),
							value: 2
						}];
						$scope.maandlast = $scope.maandlastOptions[$scope.maandlast.value];
					}, true);

					$scope.Math = $window.Math;

					$scope.getRentetarieven = function() {

						if ($scope.bedrag < 5000) $scope.bedrag = 5000;

						$scope.bezoeker.gewenstLeenbedrag = $scope.bedrag;
						$scope.bezoeker.store();

						var numb = $scope.bedrag.toString().match(/\d/g);
						$scope.bedrag = numb.join("");

						$http
							.post('/rentetarieven/getInterestAllBanks/', {
								'bedrag': $scope.bedrag,
								'product': $scope.productvorm,
								'looptijd': $scope.looptijd,
								'maandlast': $scope.maandlast.value
							})
							.success(function(data, status, headers, config) {
								$scope.rentetarieven = data;
								var banken = Object.keys(data);
								var interests = [];
								var amountOfInterests = 0;

								$scope.firstChoice = null;
								$scope.secondChoice = null;
								$scope.thirdChoice = null;

								for (var i = 0; i < banken.length; i++) {
									if (data[banken[i]].aan_te_bieden == 'ja') {
										
										if (!$scope.firstChoice) {
											$scope.firstChoice = data[banken[i]];
										} else if (!$scope.secondChoice) {
											$scope.secondChoice = data[banken[i]];
										} else if (!$scope.thirdChoice) {
											$scope.thirdChoice = data[banken[i]];
										}
									}
									rente = data[banken[i]].rente.slice(0, -1);
									rente = rente.replace(',', '.');
									rente = parseFloat(rente);
									interests.push(rente);
									amountOfInterests++;
								}

								var sum = 0;
								for (var i = interests.length - 1; i >= 0; i--) {
									sum += interests[i];
								}
								var avgOneDecimal = Math.round(sum / amountOfInterests * 10) / 10;

								if($scope.firstChoice != null){
									renteAverage1 = $scope.firstChoice.rente.slice(0, -1);
									renteAverage1 = renteAverage1.replace(',', '.');
									renteAverage1 = parseFloat(renteAverage1);
									$scope.averageRenteDifferenceOne = avgOneDecimal - renteAverage1;
								}

								if($scope.secondChoice != null){
									renteAverage2 = $scope.secondChoice.rente.slice(0, -1);
									renteAverage2 = renteAverage2.replace(',', '.');
									renteAverage2 = parseFloat(renteAverage2);
									$scope.averageRenteDifferenceTwo = avgOneDecimal - renteAverage2;
								}

								if($scope.thirdChoice != null){
									renteAverage3 = $scope.thirdChoice.rente.slice(0, -1);
									renteAverage3 = renteAverage3.replace(',', '.');
									renteAverage3 = parseFloat(renteAverage3);
									$scope.averageRenteDifferenceThree = avgOneDecimal - renteAverage3;
								}

							});

					};

					$scope.bankImages = getBankImages();

					$scope.getBankImage = function(bank) {

						if (typeof $scope.bankImages[bank] !== 'undefined')
							return $scope.bankImages[bank];
					};

					$scope.onSubmit = function($event) {
						$event.preventDefault();
						var looptijd = null;
						var maandlast = null;
						var maandtermijnIndex = null;

						if ($scope.productvorm == 'persoonlijke lening') {
							looptijd = $scope.looptijd;
						} else {
							maandtermijnIndex = $scope.maandlast.value;
						}

						$http.post('/session/saveUser/', {
							'productvorm': $scope.productvorm,
							'leenbedrag': $scope.bedrag,
							'looptijd': looptijd,
							'maandtermijnIndex': maandtermijnIndex
						}).success(function(data, status, headers, config) {
							$window.location.href = '/offerte-aanvragen/';
						});
					};

					$scope.onSubmitCombinatie = function($event) {
						$event.preventDefault();
						var looptijd = null;
						var maandlast = null;
						var maandtermijnIndex = null;

						if ($scope.productvorm == 'persoonlijke lening') {
							looptijd = $scope.looptijd;
						} else {
							maandtermijnIndex = $scope.maandlast.value;
						}

						$http.post('/session/saveUser/', {
							'productvorm': $scope.productvorm,
							'leenbedrag': $scope.bedrag,
							'looptijd': looptijd,
							'maandtermijnIndex': maandtermijnIndex
						}).success(function(data, status, headers, config) {
							$window.location.href = '/offerte-aanvragen/#?combinatie=true&productvorm=' + $scope.productvorm;
						});
					};

					$scope.getRentetarieven();
				}
			};
		}
	]
);